import React from "react";
import { View, StyleProp, ViewStyle } from "react-native";
import { Sizing } from "../../../theme";
import { Target } from "../store/MixReducer";
import { Text } from "../../../components";
import Glitch from "./Glitch";

export interface MessageBubbleProps {
  text?: string;
  children?: React.ReactNode;
  target?: Target | "eve";
  style?: StyleProp<ViewStyle>;
}

export function MessageBubble({
  text,
  children,
  target,
  style,
}: MessageBubbleProps) {
  return (
    <View
      style={[
        {
          // equivalent of inline in RNative:
          width: "auto",
          alignSelf:
            target === "alice" || target === "eve"
              ? "flex-start"
              : target === "bob"
              ? "flex-end"
              : "center",
          backgroundColor:
            target === "alice"
              ? "#E9E9EB"
              : target === "bob"
              ? "#0D83FE"
              : target == "eve"
              ? "#FFC9C9"
              : "white", // user input
          borderRadius: Sizing.cs(20),
          borderWidth: target ? 0 : 2,
          borderColor: target ? "white" : "#9BCBFF",
          paddingHorizontal: Sizing.cs(15),
          paddingVertical: Sizing.cs(10),
          maxWidth: Sizing.cs(350),
        },
        style,
      ]}
    >
      {text && (
        <Text
          style={{
            color: target === "bob" ? "white" : "black",
            textAlign: !target ? "center" : "left",
          }}
        >
          {/* "Eve" in Text in Glitch wrappen */}
          {text?.split("Eve").map((part, index) => (
            <React.Fragment key={index}>
              {part}
              {index < text.split("Eve").length - 1 && <Glitch text="Eve" />}
            </React.Fragment>
          ))}
        </Text>
      )}
      {children && <View style={{ height: Sizing.cs(15) }} />}
      {children}
    </View>
  );
}
